<div class="file-drop-container" (drop)="dropFiles($event)" (dragover)="onDragOver($event)"
  (dragenter)="onDragEnter($event)">
  <div class="file-drop-input-container">
    <input type="file" #fileSelector [accept]="accept" [attr.directory]="directory || undefined"
      [attr.webkitdirectory]="directory || undefined" [attr.mozdirectory]="directory || undefined"
      [attr.msdirectory]="directory || undefined" [attr.odirectory]="directory || undefined" [multiple]="multiple"
      (change)="uploadFiles($event)" class="file-drop-input" />
    <ng-template class="file-drop-content" [ngTemplateOutlet]="contentTemplate"
      [ngTemplateOutletContext]="{ openFileSelector: openFileSelector, startFolderSelector: startFolderSelector, cancelFolderSelector: cancelFolderSelector, longpress:longpress }">
    </ng-template>
    <div class="file-drop-overlay" (dragleave)="onDragLeave($event)" *ngIf="isDraggingOverDropZone && !dropDisabled"
      translate>UPLOADER_LANDING_BACKGROUND_DROP_TEXT</div>
  </div>
</div>